import config from 'config';
import Utils  from 'Utils';


/**
 * Navigation API class
 */
class ScrollTo {

  /**
   * [constructor description]
   * @return {[type]} [description]
   */
  constructor() {
    this.$el = $('.js-scroll');

    this.eventHandler();
  }

  eventHandler() {
    this.$el.on('click', (ev) => this.handleClick(ev));
  }

  handleClick(ev) {
    ev.preventDefault();

    let $current = $(ev.currentTarget);
    let id       = $current.attr('href');
    let top      = $(id).length > 0 ? $(id).offset().top : null;

    if (id == '#top') {
      top = 0;
    }

    this.play(top);
  }

  play(top = null) {
    if (!_.isNumber(top)) {
      return;
    }

    $('body,html').animate({
      scrollTop: top
    }, 700);
  }
}

export default ScrollTo;



// WEBPACK FOOTER //
// ./src/js/modules/ScrollTo.js